import { thunkActionLoading } from '@configs'
import { createSlice } from '@reduxjs/toolkit'
import { ISeoPage, IWorkshopEvent } from 'src/interfaces/workshopEvent'
import {
  getEventSeoAction,
  getListWorkshopEventAction,
  updateEventPageSeoAction,
} from '../actions/workshopEvent'

interface IWorkshopEventState {
  workshopEvents: IWorkshopEvent[]
  eventPageSeo: ISeoPage | undefined
  loadings: Record<string, boolean | undefined>
}

const initialState: IWorkshopEventState = {
  workshopEvents: [],
  eventPageSeo: undefined,
  loadings: {},
}

const workshopEventSlice = createSlice({
  name: 'workshopEvent',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get List Event Posts
    builder.addCase(getListWorkshopEventAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_WORKSHOP_EVENT] = true
    })
    builder.addCase(getListWorkshopEventAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_WORKSHOP_EVENT] = false
      const payload = action.payload
      state.workshopEvents = payload.data.items
    })
    builder.addCase(getListWorkshopEventAction.rejected, (state) => {
      state.loadings[thunkActionLoading.GET_WORKSHOP_EVENT] = false
    })

    //seo
    builder.addCase(getEventSeoAction.pending, (state) => {
      state.loadings[thunkActionLoading.GET_EVENT_SEO] = true
    })
    builder.addCase(getEventSeoAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVENT_SEO] = false
    })
    builder.addCase(getEventSeoAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.GET_EVENT_SEO] = false
      state.eventPageSeo = action.payload.data
    })
    builder.addCase(updateEventPageSeoAction.pending, (state) => {
      state.loadings[thunkActionLoading.UPDATE_EVENT_SEO] = true
    })
    builder.addCase(updateEventPageSeoAction.rejected, (state, action) => {
      state.loadings[thunkActionLoading.UPDATE_EVENT_SEO] = false
    })
    builder.addCase(updateEventPageSeoAction.fulfilled, (state, action) => {
      state.loadings[thunkActionLoading.UPDATE_EVENT_SEO] = false
      state.eventPageSeo = action.payload.data.commonContent
    })
  },
})

export const workshopEventActions = {
  ...workshopEventSlice.actions,
}

export default workshopEventSlice.reducer
